import { StoreData } from './reducers/typings'

import { initialState as userState } from './authorization/userSlice'
import { initialState as loadingState } from '@sales-center/common'
import { initialState as companySetup } from './companySetup/slice'
import { initialState as companyHeaderDisplaySettings } from './companyHeaderDisplaySettings/slice'
import { initialState as salesFunnelState } from './salesFunnel/slice'
import { initialState as editSalesFunnel } from './salesFunnel/editSlice'
import { initialState as salesTeam } from './salesTeam/slice'
import { initialState as branches } from './branches/slice'
import { initialState as employeesState } from './employee/slice'
import { initialState as users } from './users/slice'
import { initialState as leadsState } from './lead/slice'
import { initialState as serviceProducts } from './serviceProducts/slice'
import { initialState as leadOppProducts } from './leadOppProducts/slice'
import { initialState as serviceFrequency } from './serviceFrequency/slice'
import { initialState as opportunitiesState } from './opportunity/slice'
import { initialState as opportunityAddState } from './opportunity/addOpportunity/addOpportunitySlice'
import { initialState as roles } from './roles/slice'
import { initialState as divisions } from './divisions/slice'
import { initialState as locationTypes } from './locationTypes/slice'
import { initialState as locations } from './locations/slice'
import { initialState as targetPests } from './targetPests/slice'
import { initialState as agreements } from './agreements/slice'
import { initialState as payments } from './payments/slice'
import { initialState as dashboard } from './dashboard/slice'
import { initialState as leadNotes } from './leadNotes/slice'
import { initialState as opportunityNotes } from './opportunityNotes/slice'
import { initialState as locationNotes } from './locationNotes/slice'
import { initialState as draftLeads } from './draftLeads/slice'
import { initialState as attachments } from './attachments/slice'
import { initialState as locationDocuments } from './locationDocuments/slice'
import { initialState as sources } from './sources/slice'
import { initialState as campaigns } from './campaigns/slice'
import { initialState as notifications } from './notifications/slice'
import { initialState as userPreferences } from './userPreferences/slice'
import { initialState as salesFunnelSummary } from './salesFunnelSummary/slice'
import { initialState as entityLocations } from './entityLocations/slice'
import { initialState as discountCode } from './discountCode/slice'
import { initialState as tenantFeatures } from '@sales-center/common/tenantFeatures'
import {
  customFieldOptionsInitialState as customFieldOptions,
  customFieldsInitialState as customFields,
} from './customFields'
import { initialState as entityFormSettings } from './entityFormSettings/slice'
import { initialState as customFieldsFormSettings } from './customFieldSettings/slice'
import { initialState as entityAppointments } from './scheduling/slice'
import { initialState as entityAppointmentsSearch } from './scheduling/searchSlice'
import { initialState as cancelReasons } from './scheduling/cancelReasonsSlice'
import { initialState as techs } from './techs/slice'
import { initialState as techRegions } from './techRegions/slice'
import { initialState as overdueActivitiesCount } from '../features/Activity/store/slice'
import { initialState as assignmentRules } from './leadAssignmentRule/slice'
import { initialState as dictionaries } from './dictionaries'
import { initialState as userPreferencesGeneral } from './userPreferences/userPreferencesGeneral/slice'
import { initialState as globalSearch } from '@user/store/globalSearch'
import { initialState as callTrackingProviders } from './callTracking/slice'
import { initialState as imports } from './import/slice'
import { initialState as license } from './licensing/slice'
import { initialState as salesCenterWebhooks } from './scWebHooks/slice'
import { initialState as map } from './map/slice'
import { initialState as territory } from './territory/slice'
import { initialState as territoryDraw } from './territoryDraw/slice'
import { initialState as workWaveContactDuplicates } from './duplicates/WorkwaveContacts/slice'
import { initialState as pestPacLocationDuplicates } from './duplicates/PestPacLocations/slice'
import { initialState as guestUser } from './guestUser/slice'
import { initialState as knockStatus } from './knockStatus/slice'

export const initialState: StoreData = {
  attachments,
  loadingState,
  userState,
  companySetup,
  companyHeaderDisplaySettings,
  salesFunnelState,
  editSalesFunnel,
  salesTeam,
  branches,
  employeesState,
  users,
  leadsState,
  locationDocuments,
  serviceProducts,
  leadOppProducts,
  serviceFrequency,
  opportunitiesState,
  roles,
  divisions,
  locationTypes,
  locations,
  targetPests,
  agreements,
  payments,
  dashboard,
  leadNotes,
  opportunityNotes,
  locationNotes,
  draftLeads,
  sources,
  campaigns,
  notifications,
  userPreferences,
  salesFunnelSummary,
  entityLocations,
  discountCode,
  tenantFeatures,
  customFields,
  customFieldOptions,
  entityFormSettings,
  customFieldsFormSettings,
  entityAppointments,
  entityAppointmentsSearch,
  cancelReasons,
  techs,
  techRegions,
  overdueActivitiesCount,
  assignmentRules,
  dictionaries,
  opportunityAddState,
  userPreferencesGeneral,
  globalSearch,
  callTrackingProviders,
  imports,
  license,
  salesCenterWebhooks,
  map,
  territory,
  territoryDraw,
  workWaveContactDuplicates,
  pestPacLocationDuplicates,
  guestUser,
  knockStatus,
}
